module.exports = __webpack_public_path__ + "img/scout_dice_screenshot.039e9015.png";